import { createReducer, on } from '@ngrx/store';
import { Action } from '@ngrx/store';
import * as ChartActions from './../actions/chart.actions';
import { chartData } from '../../model/chart.model';

export interface ChartData {
    countDoneLilates: any | null,
    countDoneLilatesByStart: any | null,
    countCreatedLilates: any | null,
    monthlyCreatedLilates: any | null,
    checkDataByYearLilates: chartData | null,
    languagesLilates: any | null,
    statusLilates: any | null,
    tauxPassageLilates: any | null,
    tauxPassageLilatesPerLanguage: any | null,
    successLilates: any | null,
    successLilatesPerLanguage: any | null,
    levelLilates: any | null,
    levelPerLanguagesLilates: any | null,
    npsLilates: any | null,
    csatLilates: any | null,
    carbon: any | null,
    modeFinancementLilates: any | null,
    loading: number,
    genderLilates: any | null,
    jobSituationLilates: any | null,
    jobLilates: any | null,
    businessLilates: any | null,
    inTrainingLilates: any | null,
    identityIssueCountLilates: any | null,
    photoStatusRefusedCountLilates: any | null,
    uniqueCompaniesCountLilates: any | null,
    averageAgeLilates: any | null,
    ageRangeCountLilates: any | null,

    evolutionCountDoneLilates: any | null,
    evolutionCountDoneLilatesByStart: any | null,
    evolutionCountCreatedLilates: any | null,
    evolutionTauxPassageLilates: any | null,
    evolutionSuccessLilates: any | null,
    evolutionMonthlyCreatedLilates: any | null,
}

export const initialState: ChartData = {
    countDoneLilates: null,
    countDoneLilatesByStart: null,
    countCreatedLilates: null,
    monthlyCreatedLilates: null,
    checkDataByYearLilates: null,
    languagesLilates: null,
    tauxPassageLilates: null,
    successLilates: null,
    statusLilates: null,
    levelLilates: null,
    levelPerLanguagesLilates: null,
    npsLilates: null,
    csatLilates: null,
    carbon: null,
    tauxPassageLilatesPerLanguage: null,
    successLilatesPerLanguage: null,
    loading: 0,
    modeFinancementLilates: null,
    genderLilates: null,
    jobSituationLilates: null,
    jobLilates: null,
    businessLilates: null,
    inTrainingLilates: null,
    identityIssueCountLilates: null,
    photoStatusRefusedCountLilates: null,
    uniqueCompaniesCountLilates: null,
    averageAgeLilates: null,
    ageRangeCountLilates: null,

    evolutionCountDoneLilates: null,
    evolutionCountDoneLilatesByStart: null,
    evolutionCountCreatedLilates: null,
    evolutionTauxPassageLilates: null,
    evolutionSuccessLilates: null,
    evolutionMonthlyCreatedLilates: null,
};

const chartReducer = createReducer(
    initialState,

    on(ChartActions.GetCountDoneLilates, ChartActions.GetCountDoneLilatesByStart, ChartActions.GetCountCreatedLilates, ChartActions.GetCheckDataByYearLilates,
        ChartActions.GetLanguagesLilates, ChartActions.GetTauxPassageLilates, ChartActions.GetStatusLilates,
        ChartActions.GetLevelLilates, ChartActions.GetLevelPerLanguagesLilates, ChartActions.GetNpsLilates,
        ChartActions.GetCsatLilates, ChartActions.GetSuccessLilates, ChartActions.GetCarbon, ChartActions.GetSuccessLilatesPerLangues,
        ChartActions.GetTauxPassageLilatesPerLangues,
        ChartActions.GetModeFinancement, ChartActions.GetGenderLilates, ChartActions.GetJobSituationLilates,
        ChartActions.GetInTrainingLilates, ChartActions.GetIdentityIssueCountLilates,
        ChartActions.GetPhotoStatusRefusedCountLilates, ChartActions.GetUniqueCompaniesCountLilates,
        ChartActions.GetAverageAgeLilates, ChartActions.GetAgeRangeCountLilates,
        ChartActions.GetJobLilates, ChartActions.GetBusinessLilates,
        ChartActions.GetEvolutionCreatedLilates, ChartActions.GetEvolutionDoneLilates, ChartActions.GetEvolutionDoneLilatesByStart,
        ChartActions.GetEvolutionTauxPassageLilates, ChartActions.GetEvolutionSuccessLilates,
        ChartActions.GetEvolutionMonthlyCreatedLilates, ChartActions.GetEvolutionSuccessLilates,
        (state) => ({ ...state, loading: state.loading + 1 })),

    on(ChartActions.GetCountDoneLilatesSuccess, (state, action) => ({ ...state, countDoneLilates: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetCountDoneLilatesFailure, (state) => ({ ...state, countDoneLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetCountDoneLilatesByStartSuccess, (state, action) => ({ ...state, countDoneLilatesByStart: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetCountDoneLilatesByStartFailure, (state) => ({ ...state, countDoneLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetCountCreatedLilatesSuccess, (state, action) => ({ ...state, countCreatedLilates: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetCountCreatedLilatesFailure, (state) => ({ ...state, countCreatedLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetCountMonthlyCreatedLilatesSuccess, (state, action) => ({ ...state, monthlyCreatedLilates: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetCountMonthlyCreatedLilatesFailure, (state) => ({ ...state, monthlyCreatedLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetCheckDataByYearLilatesSuccess, (state, action) => ({ ...state, checkDataByYearLilates: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetCheckDataByYearLilatesFailure, (state) => ({ ...state, checkDataByYearLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetLanguagesLilatesSuccess, (state, action) => ({ ...state, languagesLilates: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetLanguagesLilatesFailure, (state) => ({ ...state, languagesLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetTauxPassageLilatesSuccess, (state, action) => ({ ...state, tauxPassageLilates: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetTauxPassageLilatesFailure, (state) => ({ ...state, tauxPassageLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetSuccessLilatesSuccess, (state, action) => ({ ...state, successLilates: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetSuccessLilatesFailure, (state) => ({ ...state, successLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetTauxPassageLilatesPerLanguesSuccess, (state, action) => ({ ...state, tauxPassageLilatesPerLanguage: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetTauxPassageLilatesPerLanguesFailure, (state) => ({ ...state, tauxPassageLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetSuccessLilatesPerLanguesSuccess, (state, action) => ({ ...state, successLilatesPerLanguage: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetSuccessLilatesPerLanguesFailure, (state) => ({ ...state, successLilatesPerLanguage: null, loading: state.loading - 1 })),

    on(ChartActions.GetStatusLilatesSuccess, (state, action) => ({ ...state, statusLilates: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetStatusLilatesFailure, (state) => ({ ...state, statusLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetLevelLilatesSuccess, (state, action) => ({ ...state, levelLilates: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetLevelLilatesFailure, (state) => ({ ...state, levelLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetLevelPerLanguagesLilatesSuccess, (state, action) => ({ ...state, levelPerLanguagesLilates: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetLevelPerLanguagesLilatesFailure, (state) => ({ ...state, levelPerLanguagesLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetNpsLilatesSuccess, (state, action) => ({ ...state, npsLilates: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetNpsLilatesFailure, (state) => ({ ...state, npsLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetCsatLilatesSuccess, (state, action) => ({ ...state, csatLilates: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetCsatLilatesFailure, (state) => ({ ...state, csatLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetCarbonSuccess, (state, action) => ({ ...state, carbon: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetCarbonFailure, (state) => ({ ...state, carbon: null, loading: state.loading - 1 })),

    on(ChartActions.GetModeFinancementSuccess, (state, action) => ({ ...state, modeFinancementLilates: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetModeFinancementFailure, (state) => ({ ...state, modeFinancementLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetGenderLilatesSuccess, (state, action) => ({ ...state, genderLilates: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetGenderLilatesFailure, (state) => ({ ...state, genderLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetJobSituationLilatesSuccess, (state, action) => ({ ...state, jobSituationLilates: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetJobSituationLilatesFailure, (state) => ({ ...state, jobSituationLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetJobLilatesSuccess, (state, action) => ({ ...state, jobLilates: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetJobLilatesFailure, (state) => ({ ...state, jobLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetBusinessLilatesSuccess, (state, action) => ({ ...state, businessLilates: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetBusinessLilatesFailure, (state) => ({ ...state, businessLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetInTrainingLilatesSuccess, (state, action) => ({ ...state, inTrainingLilates: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetInTrainingLilatesFailure, (state) => ({ ...state, inTrainingLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetIdentityIssueCountLilatesSuccess, (state, action) => ({ ...state, identityIssueCountLilates: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetIdentityIssueCountLilatesFailure, (state) => ({ ...state, identityIssueCountLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetPhotoStatusRefusedCountLilatesSuccess, (state, action) => ({ ...state, photoStatusRefusedCountLilates: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetPhotoStatusRefusedCountLilatesFailure, (state) => ({ ...state, photoStatusRefusedCountLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetUniqueCompaniesCountLilatesSuccess, (state, action) => ({ ...state, uniqueCompaniesCountLilates: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetUniqueCompaniesCountLilatesFailure, (state) => ({ ...state, uniqueCompaniesCountLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetAverageAgeLilatesSuccess, (state, action) => ({ ...state, averageAgeLilates: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetAverageAgeLilatesFailure, (state) => ({ ...state, averageAgeLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetAgeRangeCountLilatesSuccess, (state, action) => ({ ...state, ageRangeCountLilates: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetAgeRangeCountLilatesFailure, (state) => ({ ...state, ageRangeCountLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetEvolutionCreatedLilatesSuccess, (state, action) => ({ ...state, evolutionCountCreatedLilates: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetEvolutionCreatedLilatesFailure, (state) => ({ ...state, evolutionCountCreatedLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetEvolutionDoneLilatesSuccess, (state, action) => ({ ...state, evolutionCountDoneLilates: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetEvolutionDoneLilatesFailure, (state) => ({ ...state, evolutionCountDoneLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetEvolutionDoneLilatesByStartSuccess, (state, action) => ({ ...state, evolutionCountDoneLilatesByStart: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetEvolutionDoneLilatesByStartFailure, (state) => ({ ...state, evolutionCountDoneLilatesByStart: null, loading: state.loading - 1 })),

    on(ChartActions.GetEvolutionTauxPassageLilatesSuccess, (state, action) => ({ ...state, evolutionTauxPassageLilates: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetEvolutionTauxPassageLilatesFailure, (state) => ({ ...state, evolutionTauxPassageLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetEvolutionSuccessLilatesSuccess, (state, action) => ({ ...state, evolutionSuccessLilates: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetEvolutionSuccessLilatesFailure, (state) => ({ ...state, evolutionSuccessLilates: null, loading: state.loading - 1 })),

    on(ChartActions.GetEvolutionMonthlyCreatedLilatesSuccess, (state, action) => ({ ...state, evolutionMonthlyCreatedLilates: action.data, loading: state.loading - 1 })),
    on(ChartActions.GetEvolutionMonthlyCreatedLilatesFailure, (state) => ({ ...state, evolutionMonthlyCreatedLilates: null, loading: state.loading - 1 })),
);

export function reducer(state: ChartData | undefined, action: Action) {
    return chartReducer(state, action);
}
